var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contents"},[_c('div',{staticClass:"contents__inner"},[_c('v-card-title',[_vm._v("Videos - "+_vm._s(this.$route.params.artistName))]),_c('v-app',_vm._l((_vm.musicWithVideos),function(item){return _c('div',{key:item.name},[_c('YoutubeContainer',{attrs:{"id":item.url_youtube}})],1)}),0)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }